// src/components/Templates/SoMe/SoMe.component.tsx
import React from "react";
import { SvgIcon } from "../../Atoms/SvgIcon/SvgIcon";
import S from "./SoMe.module.scss";

interface SoMeProps {
    socials?: {
        network: string;
        name: string;
        url: string;
    }[];
}

interface LinkProps {
    href: string;
    title?: string;
    target?: string;
    // ariaLabel?: string;
}

//TODO: aria-label should be added

const SoMe: React.FC<SoMeProps> = ({ socials }) => (
    <div className={S.socialsWrapper}>
        {socials?.map((item, index) => {
            const linkProps: LinkProps = {
                href: item.url,
                title: item.name || '',
                target: '_blank',
                // ariaLabel: 
            }
            return (
                <a key={index} {...linkProps}>
                    <SvgIcon iconName={item.network} />
                </a>
            )
        })}
    </div>
);

export default SoMe;
